/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import {
  ROUTES,
  setElementHeights,
  WEB_API_BILLING,
} from '../../assets/constants/strings';
import ApiHeader from '../../components/API/UIElements/Header';
import TitleBar from '../../components/API/UIElements/TitleBar';
import AccountLeftNav from '../../components/API/AccountSettings/AccountLeftNav';
import { useParams } from 'react-router-dom';
import './style.scoped.scss';
import Footer from '../../components/Footer';
import $ from 'jquery';
import Billing from '../../components/API/BillingAndUsage/Billing';
import Usage from '../../components/API/BillingAndUsage/Usage';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { hasDeveloperApi, isAuthenticated } from '../../services/entitlements';

const mapStateToProps = (state) => ({
  user: state.user.user,
});

const connector = connect(mapStateToProps, null);

const ApiBilling = ({user}) => {
  const { page } = useParams();

  const [selectedPage, setSelectedPage] = useState(page);

  useEffect(() => {
    $(window).on('resize', setElementHeights);
  }, []);

  useEffect(() => {
    definePageTitle();
    setElementHeights();
  });

  const definePageTitle = () => {
    // need to ensure we can match to one of the pages
    let accountType = WEB_API_BILLING;
    if (
      page &&
      Object.values(accountType).filter((item) => item.URL === page).length > 0
    ) {
      setSelectedPage(page);
      document.title =
        Object.values(accountType).filter((item) => item.URL === page)[0].NAV +
        ' | RegulationCity';
    } else setSelectedPage(Object.values(accountType)[0].URL);
  };

  if (!isAuthenticated(user)) {
    return <Redirect to={`${ROUTES.LOGIN}?portal=api`} />;
  }

  if (user && !hasDeveloperApi(user)) {
    return <Redirect to={ROUTES.APIACTIVATE} />;
  }

  return (
    <div className='wf-doc-wrapper w-100' id='wf-doc-page'>
      <nav id='sticky-top-wrapper' className='navbar sticky-top p-0'>
        <div className='w-100 d-flex flex-column '>
          <ApiHeader hasNav />
          <TitleBar pageTitle='Billing History & Usage' />
        </div>
      </nav>

      <main role='main' className='wf-document px-0 mb-0' id='wf-my-account'>
        <AccountLeftNav
          isUserAccount={false}
          navigationArray={WEB_API_BILLING}
          activePage={selectedPage}
        />

        <div className='col' id='main-content'>
          {{
            [WEB_API_BILLING.BILLING.URL]: <Billing />,
            [WEB_API_BILLING.USAGE.URL]: <Usage />,
          }[selectedPage] || (
            <h1>
              Welcome to your account settings. Please select an item on the
              left navigation to get started.
            </h1>
          )}
        </div>
      </main>
      <Footer isDocument isCentered isAbsolute />
    </div>
  );
};

export default connector(ApiBilling);
